// extracted by mini-css-extract-plugin
export default {"coa-table":"Coa_coa-table__CUp95","coa-table__action":"Coa_coa-table__action__1jVO-","coa-table__action--button":"Coa_coa-table__action--button__v8xbq"};